import { render } from "./NodeDragDrop.vue?vue&type=template&id=4bb0692e"
import script from "./NodeDragDrop.vue?vue&type=script&lang=js"
export * from "./NodeDragDrop.vue?vue&type=script&lang=js"
script.render = render

export default script